import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IDRespuestasBloques } from 'api/bloques';

const initialState: IDRespuestasBloques[] = [];

const respuestasBloquesSlice = createSlice({
	name: 'respuestasBloques',
	initialState,
	reducers: {
		setRespuestaBloques: (state, action: PayloadAction<IDRespuestasBloques[]>) => {
			return action.payload;
		}
	}
});

export const { setRespuestaBloques } = respuestasBloquesSlice.actions;

export default respuestasBloquesSlice.reducer;
